import React from 'react'

const InformationIcon = ({ marginTop }) => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 17.5C13.6046 17.5 14.5 18.3954 14.5 19.5C14.5 20.6046 13.6046 21.5 12.5 21.5C11.3954 21.5 10.5 20.6046 10.5 19.5C10.5 18.3954 11.3954 17.5 12.5 17.5ZM14.5 15.5H10.5V3.5H14.5V15.5Z" fill="#3249D7"/>
    </svg>
    
    
  )
}

export default InformationIcon